import { Check, Copy, Megaphone } from "lucide-react";
import { useState } from "react";

import { linkAnuncioMeta } from "@/lib/linkAnuncioMeta";

/**
 * Como usar o link "Anúncios Meta" no Gerenciador de Anúncios (fase 1 do plano
 * de Anúncios Meta). Dois campos para colar no anúncio: a URL do site e os
 * "parâmetros de URL". A Meta troca `{{campaign.id}}` etc. pelos ids em cada
 * clique; o cardápio guarda e o pedido nasce marcado com a campanha e o
 * anúncio — é o que vira o selo "Meta" no Kanban e em Pedidos.
 */
function Campo({ rotulo, valor, copiado, onCopiar }) {
  return (
    <div className="space-y-1">
      <p className="text-xs font-semibold">{rotulo}</p>
      <div className="flex items-center gap-2">
        <code className="flex-1 min-w-0 truncate rounded-lg bg-muted px-2.5 py-1.5 text-xs">{valor}</code>
        <button onClick={onCopiar} title="Copiar"
          className={`rounded-lg border p-2 transition-colors shrink-0 ${copiado ? "border-emerald-500 text-emerald-500" : "hover:border-primary"}`}>
          {copiado ? <Check className="w-3.5 h-3.5" /> : <Copy className="w-3.5 h-3.5" />}
        </button>
      </div>
    </div>
  );
}

export default function ParametrosMeta({ link }) {
  const [copiado, setCopiado] = useState(null);
  if (!link?.track_token) return null;
  const { url, parametros } = linkAnuncioMeta(link.track_token);
  const copiar = (chave, valor) => {
    navigator.clipboard?.writeText(valor);
    setCopiado(chave);
    setTimeout(() => setCopiado(null), 2000);
  };
  return (
    <div className="rounded-xl border bg-card p-4 space-y-3" data-e2e="parametros-meta">
      <div className="flex items-center gap-2">
        <Megaphone className="w-5 h-5 text-sky-600" />
        <h2 className="text-base font-bold">Anúncios Meta: como colar no Gerenciador</h2>
      </div>
      <p className="text-sm text-muted-foreground">
        No anúncio, em <b>Destino → Site</b>, cole a URL; em <b>Rastreamento → Parâmetros de URL</b>,
        cole os parâmetros. Assim todo pedido que vier do anúncio chega marcado com a campanha
        e o anúncio que o trouxe.
      </p>
      <div className="grid gap-3 sm:grid-cols-2">
        <Campo rotulo="URL do site" valor={url} copiado={copiado === "url"} onCopiar={() => copiar("url", url)} />
        <Campo rotulo="Parâmetros de URL" valor={parametros} copiado={copiado === "params"} onCopiar={() => copiar("params", parametros)} />
      </div>
    </div>
  );
}
